import LikeButton from "components/likes/LikeButton";
import UserByline from "components/users/UserByline";
import PrivacyIcon from "components/shared/PrivacyIcon";
import Badge from "hardcover-ui/components/Badge";
import ListDropdown from "../ListDropdown/ListDropdown";
import useCurrentUserId from "hooks/user/useCurrentUserId";
import { ListSerializersListByline, UserSerializersUserByline } from "types/serializers";

export default function ListLinks({ list, user }: { list: ListSerializersListByline, user: UserSerializersUserByline }) {
  const currentUserId = useCurrentUserId();

  return (
    <div className="flex justify-between">
      <div className="flex flex-row items-center space-x-2">
        <UserByline user={user} byline="List by" size="xs" />
        {list.privacySettingId !== 1 && (
          <Badge variant="secondary" className="space-x-2">
            <PrivacyIcon privacySettingId={list.privacySettingId} size="md" />
            <span className="hidden md:inline">
              {list.privacySettingId === 2 ? "Followers Only" : "Private"}
            </span>
          </Badge>
        )}
      </div>

      <div className="flex flex-row space-x-2">
        <LikeButton likeable={list} showLikes={false} />
        {list.userId === currentUserId ? <ListDropdown list={list} user={user} /> : false}
      </div>
    </div>
  );
}
